import { QueryClient } from "@tanstack/react-query";
import { getAuthControllerGetCurrentUserQueryKey } from "./gen/auth/auth";

export const invalidateTrackQueries = (
  queryClient: QueryClient,
  trackId: string,
) =>
  Promise.all([
    queryClient.invalidateQueries({
      queryKey: ["/tracks"],
    }),
    queryClient.invalidateQueries({
      queryKey: [`/tracks/${trackId}`],
    }),
  ]);

export const invalidateAlbumQueries = (
  queryClient: QueryClient,
  albumId: string,
) =>
  Promise.all([
    queryClient.invalidateQueries({
      queryKey: ["/albums"],
    }),
    // The album detail endpoint is GET /albums/detail (the album id/slugs
    // travel in params), so the per-id prefix below never matches it.
    queryClient.invalidateQueries({
      queryKey: ["/albums/detail"],
    }),
    queryClient.invalidateQueries({
      queryKey: [`/albums/${albumId}`],
    }),
  ]);

export const invalidateCreatorQueries = (queryClient: QueryClient) =>
  Promise.all([
    // Predicate covers both id-based (/creators/{id}) and slug-based (/creators/@slug) keys
    queryClient.invalidateQueries({
      predicate: (query) =>
        typeof query.queryKey[0] === "string" &&
        query.queryKey[0].startsWith("/creators/"),
    }),
    queryClient.invalidateQueries({
      queryKey: getAuthControllerGetCurrentUserQueryKey(),
    }),
  ]);
